<script>
const _ = require('lodash')
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    icon: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      locale_title: "",
      locale_items: []
    }
  },
  methods: {
    translate : function(){
      let self = this
      self.locale_items = _.cloneDeep(self.items)
      if (self.title.includes('/')){
        let arr_text = self.title.split('/')
        for (let j = 0; j < arr_text.length; j++) {
          arr_text[j] = self.$t('pages.'+arr_text[j]);
        }
        self.locale_title = arr_text.join(" › ")
      } else {
        self.locale_title = self.$t('pages.'+self.title)
      }
      for (let i = 0; i < self.items.length; i++) {
        let text = self.items[i].text
        if(text && text.includes('/')){
          let arr_text = text.split('/')
          for (let j = 0; j < arr_text.length; j++) {
            arr_text[j] = self.$t('pages.'+arr_text[j]);
          }
          self.locale_items[i].text = arr_text.join(" › ")
        } else {
          self.locale_items[i].text = self.$t('pages.'+text)
        }
      }
    }
  },
  mounted() {
    this.translate()
  },
  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      this.translate()
    }
  },
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <b-breadcrumb
            :items="locale_items"
            class="m-0"
          ></b-breadcrumb>
        </div>
        <h4 class="page-title"><i v-if="icon" :class="icon"></i>{{ locale_title }}</h4>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
